// removed by extract-text-webpack-plugin
module.exports = {"chapterLink":"chapter-link-module__chapterLink___D5rQP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/accordion/chapter-link.module.scss
// module id = 269
// module chunks = 0